import { useQueries } from '@tanstack/react-query';
import { QueryKey } from 'common/enums/query-key';
import { MyEstateDetails } from 'common/generated/types/my-estate-details';
import { getMyEstateById } from 'services/api/estates-api.service';

export const useMultipleEstates = (estateIds: string[]) => {
  const queries = useQueries({
    queries: estateIds.map(estateId => ({
      queryKey: [QueryKey.Estate, 'my', estateId],
      queryFn: () => getMyEstateById(estateId),
      enabled: Boolean(estateId),
      staleTime: 5 * 60 * 1000, // 5 minutes
    })),
  });

  const estateDataMap = new Map<string, MyEstateDetails>();
  
  queries.forEach((query, index) => {
    if (query.data && estateIds[index]) {
      estateDataMap.set(estateIds[index], query.data);
    }
  });

  const isLoading = queries.some(query => query.isLoading);
  const hasError = queries.some(query => query.isError);

  return {
    estateDataMap,
    isLoading,
    hasError,
  };
};
